import { render, staticRenderFns } from "./AuthorizeConnectionStep.vue?vue&type=template&id=6841b5b0&"
import script from "./AuthorizeConnectionStep.vue?vue&type=script&lang=ts&"
export * from "./AuthorizeConnectionStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports